
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/gcp/private-service-connect",
      function () {
        return require("private-next-pages/security/gcp/private-service-connect.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/gcp/private-service-connect"])
      });
    }
  